
highcharts(:options="chartConfig")
